import React, { useState } from "react";
import { useCallback } from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import { findAll } from "../../services/animalHandlingAlertService";

export const ANIMAL_HANDLING_ALERT_FORM_INITIAL_STATE = {
  id: null,
  animalIds: [],
  message: null,
  visualizationType: "CONFIRM",
  expirationDate: null,
  status: "A",
};

export const AnimalHandlingAlertContext = createContext({
  dataList: [],
  isLoadingDataList: false,
  data: null,
  isDrawerVisible: false,
  isEditDrawerVisible: false,
  editData: null,
});

export const AnimalHandlingAlertContextProvider = ({ children }) => {
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState(null);
  const [isLoadingDataList, setIsLoadingDataList] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isEditDrawerVisible, setIsEditDrawerVisible] = useState(false);
  const [editData, setEditData] = useState(null);

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const fetchData = useCallback(async () => {
    setIsLoadingDataList(true);
    try {
      const {
        data: { results },
      } = await findAll({ groupId, farmId });
      setDataList(results);
    } catch (error) {
    } finally {
      setIsLoadingDataList(false);
    }
  }, [farmId, groupId]);

  const openDrawer = useCallback((data = null) => {
    if (data) setData(data);
    setIsDrawerVisible(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setData(ANIMAL_HANDLING_ALERT_FORM_INITIAL_STATE);
    setIsDrawerVisible(false);
  }, []);

  const openEditDrawer = useCallback((record) => {
    setEditData(record);
    setIsEditDrawerVisible(true);
  }, []);

  const closeEditDrawer = useCallback(() => {
    setEditData(ANIMAL_HANDLING_ALERT_FORM_INITIAL_STATE);
    setIsEditDrawerVisible(false);
  }, []);

  return (
    <AnimalHandlingAlertContext.Provider
      value={{
        dataList,
        fetchData,
        data,
        isLoadingDataList,
        isDrawerVisible,
        openDrawer,
        closeDrawer,
        isEditDrawerVisible,
        editData,
        openEditDrawer,
        closeEditDrawer,
      }}
    >
      {children}
    </AnimalHandlingAlertContext.Provider>
  );
};
